module.exports = __webpack_public_path__ + "img/cn.01b1e165.svg";